// Mémorise, pour la session (onglet) authentifiée courante, qu'un report
// ("Plus tard") de la modal de profil publicitaire a déjà eu lieu — afin de
// ne pas la réafficher à chaque navigation/remontage de PrivateRoute tant
// que l'utilisateur ne s'est pas reconnecté.
//
// Pas une source de vérité métier : le compteur réel reste côté backend
// (users.ad_profile_prompt_dismissed_count). sessionStorage sert uniquement
// à mémoriser côté UI que la modal a déjà été traitée cette session — il est
// vidé à la déconnexion (cf. AuthContext.logout) et disparaît de toute façon
// à la fermeture de l'onglet, contrairement à localStorage.
const SESSION_KEY = 'ad_profile_prompt_dismissed_this_session';

export const isAdProfilePromptDismissedThisSession = (): boolean => {
  try {
    return sessionStorage.getItem(SESSION_KEY) === '1';
  } catch {
    return false;
  }
};

export const markAdProfilePromptDismissedThisSession = (): void => {
  try {
    sessionStorage.setItem(SESSION_KEY, '1');
  } catch {
    // sessionStorage indisponible (mode privé restrictif) : la modal pourra
    // réapparaître à la navigation suivante, dégradation acceptable côté UI.
  }
};

export const resetAdProfilePromptSession = (): void => {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    // no-op
  }
};
